import { useProgressStore } from "../../../hooks/useProgress"

const ProgressBarGlobal = () => {
    let progressStore = useProgressStore();
    return <>
        {!!progressStore.progress && <div className="global-progress">
            <div className="current-progress" style={{"width": `${progressStore.progress}%`}}></div>
            <span className="progress-text">Upload in progress, please do not refresh the page</span>
        </div>}
    </>
}

export default ProgressBarGlobal